import { BrandLogo } from "@/components/Logo";
import { Reveal } from "@/components/Reveal";
import { CONTACT_EMAIL } from "@/components/aziende/plans";

const PRIVACY_URL = "https://www.iubenda.com/privacy-policy/71288716";
const EXT = { target: "_blank", rel: "noopener" };
const IUB = "iubenda-noiframe iubenda-embed iubenda-nostyle";
const LINKS = [
  { id: "privacy", label: "Privacy Policy", href: PRIVACY_URL, cls: IUB, ...EXT },
  { id: "cookie", label: "Cookie Policy", href: `${PRIVACY_URL}/cookie-policy`, cls: IUB, ...EXT },
  { id: "preferenze", label: "Preferenze cookie", href: "#", cls: "iubenda-cs-preferences-link" },
  { id: "contatti", label: "Contatti", href: `mailto:${CONTACT_EMAIL}` },
  { id: "linkedin", label: "LinkedIn", href: "https://www.linkedin.com/company/prodigy-incorporated/posts/?viewAsMember=true", ...EXT },
];

export const Footer = () => (
  <footer id="contatti" className="relative z-10 w-full px-6 pt-24 pb-12 border-t border-[#1a1b1e] bg-[#020202]" data-testid="footer">
    <Reveal className="max-w-7xl mx-auto">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
        <div>
          <BrandLogo className="footer-logo" testId="footer-logo" />
          <p className="mt-5 text-xs font-semibold tracking-[0.3em] text-titanium">PRODIGY INC.</p>
          <a href={`mailto:${CONTACT_EMAIL}`} className="footer-link mt-1 inline-flex min-h-[44px] items-center text-sm text-titanium" data-testid="footer-email">
            {CONTACT_EMAIL}
          </a>
        </div>
        <nav aria-label="Link del footer">
          <ul className="flex flex-wrap gap-x-8 gap-y-0">
            {LINKS.map(({ id, label, cls = "", ...a }) => (
              <li key={id}>
                <a {...a} className={`footer-link inline-flex min-h-[44px] items-center text-sm text-titanium ${cls}`} data-testid={`footer-link-${id}`}>
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>
      <div className="mt-16 pt-8 border-t border-[#121316]">
        <p className="text-xs text-[#5b6068]" data-testid="footer-copyright">
          © 2026 Prodigy Inc. Tutti i diritti riservati
        </p>
      </div>
    </Reveal>
  </footer>
);
